<template>
  <div class="share-popup">
    <div class="share-popup__cont">
      <button class="share-popup__close" @click="onCloseShow">
        <i class="icon-close"></i>
      </button>
      <div class="share-popup__title">
        <span class="orange">Расскажите </span>о нас в соцсетях
      </div>
      <p>
        Чем больше людей узнает о нашей работе, тем ближе станет Прекрасная
        Россия Будущего. Каждый репост — ваш небольшой вклад в борьбу с ворами и
        коррупционерами.
      </p>
      <social-list />
    </div>
    <div class="share-popup__mask" @click="onCloseShow"></div>
  </div>
</template>
<script>
import SocialList from "./SocialList/index";
export default {
  name: "Share",
  components: { SocialList },
  methods: {
    onCloseShow() {
      this.$emit("close-popup", false);
    }
  },
  mounted() {
    document.body.classList.add("no-scroll");
  },
  destroyed() {
    document.body.classList.remove("no-scroll");
  }
};
</script>
